import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { max, get } from 'lodash';

import Autopilot, { withinProductCostRange } from '../../../components/purchase-dashboard/autopilot/index';
import {
  getCurrentPurchase,
  findCurrentUserMembership,
} from '../../../selectors/purchase-selector';
import Purchase from '../../../lib/purchase';
import Membership from '../../../lib/membership';
import { reportError } from '../../../lib/error-reporter';
import {
  enableAutoPilot,
  hideAutoPilotModal,
  projectPurchase,
  AUTOPILOT_NAMESPACE,
} from '../../../actions';

const COMPONENT_ID = 'DesktopDashboardAutoPilotContainer';

class AutopilotContainer extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(data) {
    const { purchase, authentication } = this.props;

    return this.props.enableAutoPilot(purchase.id, data, authentication)
      .then(() => this.props.hideAutoPilotModal(purchase.id))
      .catch((error) => {
        reportError({
          error,
          component: COMPONENT_ID,
          params: {
            purchaseId: purchase.id,
            ...data,
            token: authentication.token,
          },
        });
        throw new SubmissionError({
          _error: error.message,
        });
      });
  }

  componentWillMount() {
    this.fetchProjections();
  }


  fetchProjections() {
    const { purchase, currentMembershipId, currentMembership } = this.props;

    const {
      group,
      productOrGroupMinSlots: minSlots,
      productOrGroupMaxSlots: maxSlots,
    } = purchase;
    const { minContribution, splitType } = group;
    const status = currentMembership ? currentMembership.status : null;
    const claimedSlots = Membership.isCommitted(status) ? currentMembership.claimedSlots : 1;
    const allowedShareAmount = get(currentMembership, 'allowedShareAmount', minContribution);
    const projectionParams = {
      id: this.props.purchase.id,
      group: {
        splitType,
        minSlots,
        maxSlots,
        minContribution,
      },
      memberships: [
        {
          id: currentMembershipId,
          claimedSlots,
          allowedShareAmount,
        },
      ],
    };

    if (Purchase.isGroupFull(purchase)) {
      projectionParams.memberships = [];
    }

    this.props.projectPurchase(projectionParams, AUTOPILOT_NAMESPACE);
  }

  render() {
    return (
      <Autopilot
        onSubmit={this.onSubmit}
        purchase={this.props.purchase}
        initialValues={this.props.initialValues}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  const { session: { authentication } } = state;

  return {
    purchase,
    authentication,
    currentMembershipId: state.memberships.current,
    currentMembership: findCurrentUserMembership(state),
    initialValues: {
      autoPilotTriggerSlots: getTriggerSlotsValue(purchase),
    },
  };
};

const getTriggerSlotsValue = (purchase) => {
  const { autoPilotTriggerSlots: triggerSlots, committedSlots, group, product } = purchase;


  if (triggerSlots && withinProductCostRange(triggerSlots, purchase.costRange)
    && triggerSlots >= committedSlots) {
    return triggerSlots;
  }

  if (Purchase.isSpecifiedPerPerson(group.splitType) && product.costs.length === 1) {
    return purchase.productOrGroupMinSlots;
  };

  let returnValue = committedSlots + 1;
  if (purchase.productOrGroupMaxSlots && committedSlots >= purchase.productOrGroupMaxSlots) {
    returnValue = committedSlots;
  }

  return max([returnValue, purchase.productOrGroupMinSlots]);
}

const mapDispatchToProps = {
  projectPurchase,
  enableAutoPilot,
  hideAutoPilotModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(AutopilotContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/purchase-dashboard/autopilot/index.container.js